import { Injectable } from '@angular/core';
import { StatusEntity } from '../../domain/entities/status.entity';
import { StatusDetailEntity } from '../../domain/entities/status-detail.entity';
import { StatusCategoryEntity } from '../../domain/entities/status-category.entity';
import { StatusUsageCaseTypeEntity } from '../../domain/entities/status-usage-case-type.entity';
import { StatusUsageEntity } from '../../domain/entities/status-usage.entity';
import { StatusSource } from '../../domain/enums/status-source.enum';
import { StatusResponseDto } from '../dtos/status-response.dto';
import { StatusDetailResponseDto } from '../dtos/status-detail-response.dto';
import { StatusCategoryResponseDto } from '../dtos/status-category-response.dto';
import { StatusUsageCaseTypeResponseDto } from '../dtos/status-usage-case-type-response.dto';
import { StatusUsageResponseDto } from '../dtos/status-usage-response.dto';

@Injectable({ providedIn: 'root' })
export class StatusMapper {
  public toDomain(dto: StatusResponseDto): StatusEntity {
    return {
      id: dto.id,
      name: dto.name,
      color: dto.color,
      description: dto.description,
      source: dto.source as StatusSource,
      categoryId: dto.categoryId,
      categoryName: dto.categoryName,
      isActive: dto.isActive,
      isProtected: dto.isProtected,
      sortOrder: dto.sortOrder,
      originalName: dto.originalName,
      usedByCount: dto.usedByCount ?? 0,
    };
  }

  public toDomainArray(dtos: StatusResponseDto[]): StatusEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }

  public toDetailDomain(dto: StatusDetailResponseDto): StatusDetailEntity {
    return {
      ...this.toDomain(dto),
      createdOn: dto.createdOn,
      updatedOn: dto.updatedOn,
      defaultColor: dto.defaultColor,
      defaultDescription: dto.defaultDescription,
      defaultCategoryId: dto.defaultCategoryId,
    };
  }

  public toCategoryDomain(dto: StatusCategoryResponseDto): StatusCategoryEntity {
    return {
      id: dto.id,
      name: dto.name,
    };
  }

  public toCategoryDomainArray(dtos: StatusCategoryResponseDto[]): StatusCategoryEntity[] {
    return dtos.map((dto) => this.toCategoryDomain(dto));
  }

  public toUsageCaseTypeDomainArray(dtos: StatusUsageCaseTypeResponseDto[]): StatusUsageCaseTypeEntity[] {
    return dtos.map((dto) => ({ id: dto.id, name: dto.name }));
  }

  public toUsageDomain(dto: StatusUsageResponseDto): StatusUsageEntity {
    return {
      assignedTypes: this.toUsageCaseTypeDomainArray(dto.assignedTypes ?? []),
      usedByRecordCount: dto.usedByRecordCount ?? 0,
    };
  }
}
